import React, { useState, useEffect } from 'react';
import './ImageModal.css';

const ImageModal = ({ images, currentIndex, onClose }) => {
  const [activeIndex, setActiveIndex] = useState(currentIndex);

  useEffect(() => {
    
    document.body.style.overflow = 'hidden';
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
      if (e.key === 'ArrowLeft') handlePrevious();
      if (e.key === 'ArrowRight') handleNext();
    };

    //window.addEventListener('keydown', handleKeyDown);
    //return () => window.removeEventListener('keydown', handleKeyDown);
  }, [activeIndex]);

  const handlePrevious = () => {
    setActiveIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="modal-container">
        {/* Close Button */}
        <button 
          className="modal-close-btn"
          onClick={onClose}
          aria-label="Close modal"
        >
          <span className="material-symbols-outlined notranslate">close</span>
        </button>

        {/* Navigation Buttons */}
        <button 
          className="modal-nav-btn modal-prev-btn"
          onClick={handlePrevious}
          aria-label="Previous image"
        >
          <span className="material-symbols-outlined notranslate">chevron_left</span>
        </button>

        <button 
          className="modal-nav-btn modal-next-btn"
          onClick={handleNext}
          aria-label="Next image"
        >
          <span className="material-symbols-outlined notranslate">chevron_right</span>
        </button>

        {/* Image Container */}
        <div className="modal-image-container">
          <img 
            src={images[activeIndex].url} 
            alt={images[activeIndex].title}
            className="modal-image"
          />
          
          {/* Image Info */}
          <div className="modal-image-info">
            <h3 className="modal-image-title">{images[activeIndex].title}</h3>
            <p className="modal-image-counter">
              {activeIndex + 1} / {images.length}
            </p>
          </div>
        </div>

        {/* Thumbnails */}
        <div className="modal-thumbnails">
          {images.map((image, index) => (
            <div 
              key={image.id}
              className={`modal-thumbnail ${index === activeIndex ? 'active' : ''}`}
              onClick={() => setActiveIndex(index)}
            >
              <img 
                src={image.url} 
                alt={image.title}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ImageModal;